(() => {
  const setup = () => {
    const grid = document.querySelector('.pwfaq-grid');
    if (!grid || grid.dataset.pwCompactReady) return;
    grid.dataset.pwCompactReady = 'true';

    const extraItems = [...grid.querySelectorAll('.pwfaq-item')].slice(6);
    if (!extraItems.length) return;

    const button = document.createElement('button');
    button.className = 'pwfaq-more';
    button.type = 'button';
    button.textContent = 'Voir les autres questions';
    button.setAttribute('aria-expanded', 'false');
    grid.after(button);

    const sync = () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      extraItems.forEach((item) => { item.hidden = !expanded; });
      button.hidden = false;
    };

    button.addEventListener('click', () => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      button.textContent = expanded ? 'Voir les autres questions' : 'Réduire les questions';
      sync();
    });

    sync();

    const reviews = document.querySelector('.pwce__testimonials');
    const reviewTrack = document.querySelector('.pwce__reviews');
    const method = document.querySelector('#pw-process');
    if (reviews && method && !reviews.dataset.pwMoved) {
      const wrapper = document.createElement('div');
      wrapper.className = 'pwce pwce--reviews-after-method';
      const methodSection = method.closest('.shopify-section') || method;
      methodSection.after(wrapper);
      wrapper.append(reviews);
      if (reviewTrack) wrapper.append(reviewTrack);
      reviews.dataset.pwMoved = 'true';
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup, { once: true });
  } else {
    setup();
  }
})();
